export default __webpack_public_path__ + "static/media/gravity_1.5df0e83d.png";